// src/AppProvider.tsx
import React from 'react';
import { MantineProvider } from '@mantine/core';
import { Router } from './routing/Router';
import '@mantine/core/styles.css';
import '@mantine/charts/styles.css';
import '@mantine/dates/styles.css';
import {theme} from "./util/theming";
import '@mantine/dropzone/styles.css';


export const AppProvider = () => {
    return (
        <MantineProvider theme={theme} defaultColorScheme={"dark"}>
            <Router />
        </MantineProvider>
    );
};
